<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="60%" :visible.sync="viewData.visible">
    <div>
        <el-tabs>
            <el-tab-pane :key="1" label="基础信息" class="tab_style">
                <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" size="small" label-width="0px" class="org-dialog-form">
                    <div class="des_box">
                        <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                            <el-descriptions-item label="采购项目管理员:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="projectManagerId">
                                    {{dataForm.projectManagerName}}&nbsp;&nbsp;<el-button v-if="viewFlag !== 'view' && dataForm.projectStatus === '0'" size="small" @click="selectPM()">选择</el-button>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="车型:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="carType">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.projectStatus === '0'" v-model="dataForm.carType" placeholder="车型" size="small"></el-input>
                                    <span v-else>{{dataForm.carType}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="项目编码:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="projectCode">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.projectStatus === '0'" v-model="dataForm.projectCode" placeholder="项目编码" size="small"></el-input>
                                    <span v-else>{{dataForm.projectCode}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="项目状态:" :label-style="getStyle()" :content-style="getStyle2()">
                                <!-- 进行中 已完成 -->
                                <el-form-item style="margin-bottom: 0;" prop="projectStatus">
                                    <span>{{getLabelByValue(PROJECT_STATUS,dataForm.projectStatus)}}</span>
                                    <!-- <el-select  v-else v-model="dataForm.projectStatus" placeholder="请选择" size="small" >
                                <el-option v-for="item in PROJECT_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select> -->
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="项目名称:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="projectName">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.projectStatus === '0'" v-model="dataForm.projectName" placeholder="项目名称" size="small"></el-input>
                                    <span v-else>{{dataForm.projectName}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="项目创建时间:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="createProjectTime">
                                    <el-date-picker v-if="viewFlag !== 'view' && dataForm.projectStatus === '0'" v-model="dataForm.createProjectTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
                                    </el-date-picker>
                                    <span v-else>{{dataForm.createProjectTime}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="采购负责人" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="supplyResponsorId">
                                    {{dataForm.supplyResponsor}}&nbsp;&nbsp;
                                    <el-button v-if="viewFlag !== 'view' && dataForm.projectStatus === '0'" size="small" @click="selectResponsor(0)">
                                        选择
                                    </el-button>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="项目总监" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="techResponsor">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.projectStatus === '0'" v-model="dataForm.techResponsor" placeholder="项目总监" size="small"></el-input>
                                    <span v-else>{{dataForm.techResponsor}}</span>
                                    <!-- <span v-else>{{dataForm.techResponsor}}</span>
                                    {{dataForm.techResponsor}}&nbsp;&nbsp;
                                    <el-button v-if="viewFlag !== 'view' && dataForm.projectStatus === '0'" size="small" @click="selectResponsor(1)">
                                        选择
                                    </el-button> -->
                                </el-form-item>
                            </el-descriptions-item>

                            <el-descriptions-item label="质量负责人" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="qualityResponsor">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.projectStatus === '0'" v-model="dataForm.qualityResponsor" placeholder="质量负责人" size="small"></el-input>
                                    <span v-else>{{dataForm.qualityResponsor}}</span>
                                    <!-- {{dataForm.qualityResponsor}}&nbsp;&nbsp;
                                    <el-button v-if="viewFlag !== 'view' && dataForm.projectStatus === '0'" size="small" @click="selectResponsor(2)">
                                        选择
                                    </el-button> -->
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="前提条件:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="preconditions" size="small">
                                    <!-- 特殊约定 -->
                                    <el-input v-if="viewFlag !== 'view' && dataForm.projectStatus === '0'" type="textarea" v-model="dataForm.preconditions" :rows="3" placeholder="前提条件"></el-input>
                                    <span v-else>{{dataForm.preconditions}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <!--  <el-row v-if="false">
        <el-col :span="24" >
          <el-form-item label="路径" prop="path">
            <el-input v-model="dataForm.path" readonly placeholder="路径"></el-input>
          </el-form-item>
        </el-col>
      </el-row>   -->
                    <span style="position:absolute;bottom:0;right:0;">
                        <el-button size="small" @click="viewData.visible = false">
                            取消
                        </el-button>
                        <el-button v-if="isAuth('sourcing:project:newbutton') && viewFlag !== 'view' && dataForm.projectStatus == '0'" size="small" type="primary" plain @click="dataFormSubmit()" :loading="loading">
                            保存
                        </el-button>
                        <el-button v-if="isAuth('sourcing:project:newbutton') && viewFlag !== 'view' && dataForm.projectStatus == '0'" :disabled="!dataForm.id" size="small" type="success" plain @click="dataFormPublish()" :loading="loading">
                            发布
                        </el-button>
                    </span>

                </el-form>
            </el-tab-pane>
            <el-tab-pane :key="2" label="汇率" class="tab_style">
                <!-- tab -->
                <!-- 美日欧英RMB -->
                <el-button size="small" v-if="isAuth('sourcing:project:newbutton') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateRateHandle()" icon="el-icon-plus" :disabled="!dataForm.id" class="mb15 fr">
                    新增汇率
                </el-button>
                <el-table :data="rateList" row-key="id" size="small" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" class="mb15">
                    <el-table-column type="index" width="50" label="序号">
                    </el-table-column>
                    <el-table-column prop="rmb" header-align="center" align="right" label="人民币" :formatter="rounding">
                    </el-table-column>
                    <el-table-column prop="dollar" header-align="center" align="right" label="美元" :formatter="rounding">
                    </el-table-column>
                    <el-table-column prop="yen" header-align="center" align="right" label="日元" :formatter="rounding">
                    </el-table-column>
                    <el-table-column prop="euro" header-align="center" align="right" label="欧元" :formatter="rounding">
                    </el-table-column>
                    <el-table-column prop="pound" header-align="center" align="right" label="英镑" :formatter="rounding">
                    </el-table-column>
                    <el-table-column prop="referTime" header-align="center" align="right" label="日期" width="170" :formatter="dateFormat">
                    </el-table-column>
                    <el-table-column v-if="isAuth('sourcing:project:newbutton') && viewFlag !== 'view'" header-align="center" align="left" width="140" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="addOrUpdateRateHandle(scope.row.id)" icon="el-icon-edit">
                                修改
                            </el-button>
                            <el-button type="text" size="small" @click="deleteRate(scope.row.id)" icon="el-icon-delete" class="button-danger">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :key="3" label="产销规划" class="tab_style">
                <!-- <el-form-item label="产销计划" prop="orderRequirement"> -->
                <el-row style="margin-bottom:0">
                    <el-col :span="24">
                        <!-- 缺少时间选择时间 -->
                        <!-- <span>SOP年：</span>
                    <el-date-picker  v-model="dataForm.year" value-format="yyyy" type="year" @change="dimensionListByChangeYear($event)" placeholder="选择年" size="small" class="mb15">
                    </el-date-picker> -->
                        <el-button style="margin-left:15px" size="small" v-if="isAuth('sourcing:project:newbutton') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateDimensionHandle()" icon="el-icon-plus" :disabled="!dataForm.id" class="mb15 fr">
                            新增产销计划
                        </el-button>
                    </el-col>
                </el-row>

                <el-table :data="dimensionList" row-key="id" size="small" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" class="mb15">
                    <el-table-column type="index" width="50" label="序号">
                    </el-table-column>
                    <el-table-column prop="carPlatform" header-align="center" align="left" label="车系平台" width="150">
                    </el-table-column>
                    <el-table-column prop="baseCarType" header-align="center" align="left" label="基础车型" width="150">
                    </el-table-column>
                    <el-table-column prop="baseCarTypeDesc" header-align="center" align="left" label="基础车型描述" width="200">
                    </el-table-column>
                    <el-table-column prop="sop" header-align="center" align="left" label="SOP" width="120">
                    </el-table-column>
                    <el-table-column prop="sop1" header-align="center" align="left" label="SOP+1" width="120">
                    </el-table-column>
                    <el-table-column prop="sop2" header-align="center" align="left" label="SOP+2" width="120">
                    </el-table-column>
                    <el-table-column prop="sop3" header-align="center" align="left" label="SOP+3" width="120">
                    </el-table-column>
                    <el-table-column prop="sop4" header-align="center" align="left" label="SOP+4" width="120">
                    </el-table-column>
                    <el-table-column prop="sop5" header-align="center" align="left" label="SOP+5" width="120">
                    </el-table-column>
                    <el-table-column v-if="isAuth('sourcing:project:newbutton') && viewFlag !== 'view'" header-align="center" align="left" width="140" label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="addOrUpdateDimensionHandle(scope.row.id)" icon="el-icon-edit">
                                修改
                            </el-button>
                            <el-button type="text" size="small" @click="deleteHandleDimension(scope.row.id)" icon="el-icon-delete" class="button-danger">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- </el-form-item> -->
            </el-tab-pane>
            <el-tab-pane :key="4" label="附件文件" class="tab_style">
                <!-- 上传下载 产看 需求文档 -->
                <FileUpDown ref="FileUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FileUpDown>
                <div>
                   <span>需要上传附件有：<br>立项报告 <br>可行性分析 <br>项目一级计划 <br>项目组织架构 <br>立项审批单</span> 
                </div>
            </el-tab-pane>
        </el-tabs>
        <common-user-dialog ref="commonUserDialog"></common-user-dialog>
        <!-- 弹窗, 新增 / 修改 零件-->
        <!-- 生产量纲 -->
        <add-or-update-dimension v-if="addOrUpdateDimensionVisible" ref="addOrUpdateDimension" @refreshDimensionDataList="getDimensionList"></add-or-update-dimension>
        <!-- 弹窗, 新增 / 修改 汇率表-->
        <!-- 汇率表 -->
        <add-or-update-rate v-if="addOrUpdateRateVisibe" ref="addOrUpdateRate" @refreshRateDataList="getProjectRateList"></add-or-update-rate>
    </div>
</el-dialog>
</template>

<script>
import {
    editProject,
    createProject,
    queryById,
    getDimensionList, // 生产量纲
    getProjectRateList, // 汇率表
    removeDimension,
    removeRate
} from '@/controller/project'
import moment from 'moment'
import {
    USER_TYPE,
    CAR_TYPE,
    getCAR_TYPE,
    DIALOG_CLOSED_TYPE,
    PROJECT_STATUS,
    getLabelByValue,
} from '@/utils/const'
import CommonUserDialog from "@/views/common/common-user-dialog";
// require('@/mock/mockProject');
import AddOrUpdateDimension from "./dimension-add-or-update"; // 生产量纲
import AddOrUpdateRate from "./rate-add-or-update";
import FileUpDown from "@/views/common/file-up-down";
import {
    setLoading
} from "@/utils/index";

export default {
    data() {
        return {
            FILE_BIZ_TYPE: 6,
            loading: false,
            viewData: {
                visible: false,
                width: ''
            },
            
            dimensionList: [],
            rateList: [],
            disabled_flag: true,
            CAR_TYPE: CAR_TYPE,
            getCAR_TYPE: getCAR_TYPE,
            PROJECT_STATUS: PROJECT_STATUS,
            getLabelByValue: getLabelByValue,
            addOrUpdateDimensionVisible: false,
            addOrUpdateRateVisibe: false,
            viewFlag: '',
            dataForm: {
                projectManagerId: '',
                projectManagerName: '',
                carType: '',
                projectCode: '',
                projectStatus: '',
                projectName: '',
                preconditions: '',
                createProjectTime: '',
                year: '',
                supplyResponsorId: "",
                supplyResponsor: "",
                techResponsorId: "",
                techResponsor: "",
                qualityResponsorId: "",
                qualityResponsor: '',
            },
            dataRule: {
                projectManagerId: [{
                    message: '请选择项目负责人',
                    trigger: 'blur',
                    required: true,
                }],
                supplyResponsorId: [{
                    message: "请选择采购负责人",
                    trigger: "blur",
                    required: true,
                }],
                techResponsor: [{
                    message: "请选择项目总监",
                    trigger: "blur",
                    required: true,
                }],
                qualityResponsor: [{
                    message: "请填写质量负责人",
                    trigger: "blur",
                    required: true,
                }],
                carType: [{
                    message: "请填写车型",
                    trigger: "blur",
                    required: true,
                }],
                projectCode: [{
                    message: "请填写项目编码",
                    trigger: "blur",
                    required: true,
                }],
                projectName: [{
                    message: "请填写项目名称",
                    trigger: "blur",
                    required: true,
                }],
                createProjectTime: [{
                    message: "请填写项目创建时间",
                    trigger: "blur",
                    required: true,
                }],
            },
        }
    },
    components: {
        CommonUserDialog,
        AddOrUpdateDimension, // 生产量纲表
        AddOrUpdateRate, // 汇率表
        FileUpDown //上传附件
    },
    mounted() {},
    methods: {
        //保留小数点后三位
        rounding(row, column) {
            return Number(Number(row[column.property]).toFixed(3))
        },
        dimensionListByChangeYear(year) {
            this.getDimensionList(year)
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("yyyy-MM-DD")
        },
        init(data, id, viewFlag) {
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0;
            this.dataForm.projectStatus = this.dataForm.projectStatus || '0';
            this.dataForm.projectManagerName = ''
            this.dimensionList = [];
            this.rateList = [];
            this.viewData.visible = true
            this.dataForm.supplyResponsorId = ''
            this.dataForm.supplyResponsor = "",
            this.dataForm.techResponsorId = "",
            this.dataForm.techResponsor = "",
            this.dataForm.qualityResponsorId = "",
            this.dataForm.qualityResponsor = '',
            this.loading = false
            this.$nextTick(() => {
                //初始化上传附件
                this.$refs.FileUpDown.init(this.viewFlag);
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    queryById({}, this.dataForm.id).then(data => {
                        if (data && data.code === '00') {
                            this.dataForm = data.body;
                            this.dataForm.createProjectTime = moment(this.dataForm.createProjectTime).format("yyyy-MM-DD HH:mm:ss")
                        }
                    });
                    // ============== 生产量纲数据取得 ==================
                    this.getDimensionList();
                    // ============== 汇率表数据取得 ==================
                    this.getProjectRateList();
                }
            })
        },
        dataFormPublish() {
            this.dataForm.projectStatus = '1'
            this.dataFormSubmit()
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                let params = this.dataForm
                if (valid) {
                    this.loading = true
                    if (this.dataForm.id) {
                        editProject(params).then(data => {
                            if (data && data.code === '00') {
                                // this.dataForm = data.body;
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.loading = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createProject(params).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.id = data.body ? data.body.id : '';
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.loading = false
                                        this.$emit('refreshDataList')
                                    }
                                })

                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },

        selectPM() {
            // this.$nextTick(() => {
            //     this.dataForm.projectManagerName = 'test'
            // })
            //const _this = this
            this.$refs.commonUserDialog.open(USER_TYPE.MANAGER)
            this.$refs.commonUserDialog.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    this.dataForm.projectManagerId = payload.data.defaultPositionId
                    this.dataForm.projectManagerName = payload.data.realName
                }
            };
        },

        // ================ 生产量纲表格 ========================
        // 查产销计划表
        getDimensionList(year = '') {
            getDimensionList({
                year: year,
                projectId: this.dataForm.id
            }).then((data) => {
                if (data && data.code === "00") {
                    this.dimensionList = data.body.records;
                } else {
                    this.dimensionList = [];
                }
            });
        },
        // 删除量纲
        deleteHandleDimension(id) {
            let ids = id ? [id] :
                this.dataListSelections.map((item) => {
                    return item.id;
                });
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    removeDimension(ids)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getDimensionList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        // 产销计划
        // 新增 / 修改 产销计划表
        addOrUpdateDimensionHandle(id) {
            this.addOrUpdateDimensionVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdateDimension.init(id, this.dataForm.id);
            });
        },
        // ================ 汇率表表格 ========================
        // 查询汇率表
        getProjectRateList() {
            // console.log(this.dataForm.id, 'this.dataForm.id')
            getProjectRateList({
                projectId: this.dataForm.id
            }).then((data) => {
                if (data && data.code === "00") {
                    this.rateList = data.body.records;
                } else {
                    this.rateList = [];
                }
            });
        },
        // 删除汇率表
        deleteRate(id) {
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    removeRate({}, id)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getProjectRateList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        selectResponsor(type) {
            const _this = this;
            this.$refs.commonUserDialog.open();
            this.$refs.commonUserDialog.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    // this.dataForm.projectManagerId = payload.data.id
                    switch (type) {
                        case 0:
                            _this.dataForm.supplyResponsorId = payload.data.defaultPositionId;
                            _this.dataForm.supplyResponsor =
                                payload.data.realName;
                            break;
                        case 1:
                            _this.dataForm.techResponsorId = payload.data.defaultPositionId;
                            _this.dataForm.techResponsor =
                                payload.data.realName;
                            break;
                        case 2:
                            _this.dataForm.qualityResponsorId = payload.data.defaultPositionId;
                            _this.dataForm.qualityResponsor =
                                payload.data.realName;
                            break;
                        default:
                    }
                }
            };
        },
        // 新增 / 修改 汇率表
        addOrUpdateRateHandle(id) {
            this.addOrUpdateRateVisibe = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdateRate.init(id, this.dataForm.id);
            });
        },
        getStyle() {
            return 'width: 160px; text-align: right'
        },
        getStyle2() {
            return 'width: 395.5px;'
        }
    },
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

form.el-form.org-dialog-form {
    width: 100%;
}

.linetext {
    white-space: pre-line;
}

.el-tabs__item {
    user-select: none;
}

.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}

.mb15 {
    margin-bottom: 15px;
}

.el-form-item__error {
    padding-top: 0;
}

.tab_style {
    min-height: 44vh;
}
</style>
